import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ROUTES } from '../Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/Bookdemo.css';
import { Logo } from './header';

const footerLinks = {
    Company: ['About', 'Contact', 'Careers · coming soon'],
    Platform: ['For Dentists', 'For Labs', 'Book Demo'],
    Discover: ['Find a Dentist', 'FAQ', 'Blog · coming soon'],
    Legal: ['Terms & Conditions', 'Refund Policy', 'Privacy Policy'],
};


export const ToothZapFooter2: React.FC = () => {
    const navigate = useNavigate();

    return (
        <footer className="tz-footer2 mt-5 pt-3">
            <div className="container-fluid px-0 mx-0">
             

  <div className="tz-footer-bottom2">
  <a href="/Termsandconditions">Terms</a>
  <span>·</span>
  <a href="/PrivacyPolicy">Privacy</a>
  <span>·</span>
  <a href="/RefundPolicy">Refund</a>
</div>
            </div>
        </footer>
    );
};